import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    NullableBooleanInput,
    useRecordContext,
    required,
    SelectInput,
    useEditContext,
    FormDataConsumer,
    AutocompleteInput,
    NumberInput,
} from 'react-admin';
import { Contents } from '../../custom';
import { EditToolbar } from '../../common/EditToolbar';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import FileUpload from '../../common/inputs/FileUpload';
import { CONTENT_TYPES, STATUS } from '../../common/constants';
import VideoAutocompleteInput from '../../common/inputs/VideoAutocompleteInput';
import PdfAutocompleteInput from '../../common/inputs/PdfAutoCompleteInput';
import PdfUrlPrefilled from '../../common/inputs/PdfUrlPrefilled';
import AddExerciseAutoComplete from '../../common/inputs/AddExerciseAutoComplete';

const EditForm = () => {
    const { record } = useEditContext();
    const [selectedPdfUrl, setSelectedPdfUrl] = React.useState<string | null>('');
    return (
        <SimpleForm toolbar={<EditToolbar />} defaultValues={record}>
            <TextInput source="title" fullWidth validate={[required()]} />
            <FileUpload
                type="VIDEO_THUMBNAIL"
                label={'Thumbnail'}
                source="thumbnail"
                accept={'image/*'}
            />
            <AutocompleteInput
                source="type"
                validate={[required()]}
                label={'Type'}
                fullWidth
                readOnly={true}
                choices={CONTENT_TYPES}
            />
            <SelectInput
                source="status"
                label={'Status'}
                fullWidth
                validate={[required()]}
                choices={STATUS}
            />
            <FormDataConsumer>
                {({ formData, ...rest }) => {
                    if (formData.type === 'LECTURES') {
                        return (
                            <>
                                <VideoAutocompleteInput
                                    type={'VIDEOS'}
                                    fullWidth
                                    formData={formData}
                                    source={'videoId'}
                                />
                                <TextInput
                                    source="restrictionMaxdurationMultiple"
                                    type={'number'}
                                    fullWidth
                                />
                                <TextInput
                                    source="restrictionMaxNumberPlayback"
                                    type={'number'}
                                    fullWidth
                                />
                            </>
                        );
                    }
                    if (formData.type === 'NOTES') {
                        return (
                            <>
                                <PdfAutocompleteInput
                                    type={'NOTES'}
                                    fullWidth
                                    formData={formData}
                                    source={'pdfId'}
                                    selectedPdfUrl={selectedPdfUrl}
                                    setSelectedPdfUrl={setSelectedPdfUrl}
                                />

                                <PdfUrlPrefilled
                                    fullWidth
                                    formData={formData}
                                    source={'pdfUrl'}
                                    selectedPdfUrl={selectedPdfUrl}
                                />
                            </>
                        );
                    }
                    if (formData.type === 'EXERCISES') {
                        return (
                            <>
                                <AddExerciseAutoComplete
                                    fullWidth
                                    formData={formData}
                                    source={'exerciseId'}
                                />
                            </>
                        );
                    }
                    return <></>;
                }}
            </FormDataConsumer>
            <NullableBooleanInput source={'isDemo'} fullWidth label={'Is Demo'} />
            <NumberInput source="displayOrder" type={'number'} fullWidth />
        </SimpleForm>
    );
};
const ContentEdit = () => {
    let { programId, subjectId, contentId, chapterId, topicId } = useParams();

    if (!contentId) {
        return <LoadingSection />;
    }
    return (
        <Edit
            mutationMode={'pessimistic'}
            title={<ContentTitle />}
            redirect={() => {
                return `programs/${programId}/subjects/${subjectId}/chapters/${chapterId}/topics/${topicId}/contents`;
            }}
            resource={'contents'}
            id={contentId}
        >
            <EditForm />
        </Edit>
    );
};

const ContentTitle = () => {
    const record = useRecordContext<Contents>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.contents.name', { smart_count: 1 })} &quot;
            {record.title}&quot;
        </span>
    ) : null;
};

export default ContentEdit;
